import allRoutes from "../routes";

const alwaysInclude = new Set(["dashboard", "sign-in", "sign-up", "notifications"]);

const normalize = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

/*
 * Read complete permissions from sessionStorage
 *
 * Structure:
 *
 * {
 *   modules: [],
 *   tabs: [],
 *   buttons: [],
 *   actions: []
 * }
 */
const readPermissions = () => {
  const stored = sessionStorage.getItem("permissions");

  if (!stored) {
    return null;
  }

  try {
    return JSON.parse(stored);
  } catch (error) {
    console.error("Failed to parse permissions:", error);

    return null;
  }
};

export default function getFilteredRoutes() {
  const permissions = readPermissions();

  /*
   * No permissions:
   * show only mandatory routes.
   */
  if (!permissions) {
    return allRoutes.filter((route) => alwaysInclude.has(normalize(route.key)));
  }

  /*
   * permissions.modules comes from:
   *
   * getUserPermissions(roleId)
   *
   * Example:
   *
   * {
   *   module_id: "1",
   *   module: {
   *     module_name: "Staff"
   *   }
   * }
   */
  const roleModules = Array.isArray(permissions.modules) ? permissions.modules : [];

  const allowedModules = new Set();

  roleModules.forEach((roleModule) => {
    /*
     * Module name
     */
    const moduleName = roleModule?.module?.module_name;

    if (moduleName) {
      allowedModules.add(normalize(moduleName));
    }

    /*
     * Optional support if API directly
     * returns module_name.
     */
    if (roleModule?.module_name) {
      allowedModules.add(normalize(roleModule.module_name));
    }
  });

  /*
   * Filter routes
   */
  return allRoutes.filter((route) => {
    const routeKey = normalize(route.key);
    const routeName = normalize(route.name);

    /*
     * Always show Dashboard / Sign In / Sign Up
     */
    if (alwaysInclude.has(routeKey)) {
      return true;
    }

    /*
     * Match:
     *
     * route.key
     *     OR
     * route.name
     *
     * with module.module_name
     */
    return allowedModules.has(routeKey) || allowedModules.has(routeName);
  });
}
